import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridContainer, GridItem, Link } from "@insite/mobius/index";
import React, { useContext, useState } from "react";
import { FC } from "react";
import { css } from "styled-components";
import { GridItemProps } from "@insite/mobius/GridItem";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import Zone from "@insite/client-framework/Components/Zone";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import translate from "@insite/client-framework/Translate";
import ADIDealerLocatorSearchForm from "@NA/Components/ADIDealerLocatorSearchForm";
import siteMessage from "@insite/client-framework/SiteMessage";
import useLocationFilterSearch, { LocationModel } from "@insite/client-framework/Common/Hooks/useLocationFilterSearch";
import { GetDealersApiParameter } from "@insite/client-framework/Services/DealerService";
import {
    getDealersDataView,
    getDealersDefaultLocation,
} from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";

import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import LocationSearchForm, { LocationSearchFormStyles } from "@NA/Overrides/Components/LocationSearchForm";
import {
    getGeoCodeFromAddress,
    getGeoCodeFromLatLng,
} from "@insite/client-framework/Common/Utilities/GoogleMaps/getGeoCodeFromAddress";
import LocationFinderDealerDisplay, {
    LocationFinderDealerDisplayPresentationProps,
} from "@insite/content-library/Widgets/LocationFinder/LocationFinderDealerDisplay";

import useLocationGoogleMarkers, {
    CurrentLocationInfoWindow,
    LocationInfoWindow,
} from "@NA/Overrides/Common/Hooks/useLocationGoogleMarkers";

import LocationGoogleMap, { LocationGoogleMapStyles } from "@NA/Overrides/Components/LocationGoogleMap";
import setParameter from "@insite/client-framework/Store/Pages/LocationFinder/Handlers/SetParameter";
import loadDealers from "@insite/client-framework/Store/Data/Dealers/Handlers/LoadDealers";
import customLoadDealers from "@NA/Overrides/Store/Data/Dealers/Handlers/LoadDealers";

import withDynamicGoogleMaps from "@insite/client-framework/Common/withDynamicGoogleMaps";
import useGoogleMaps from "@insite/client-framework/Common/Hooks/useGoogleMaps";
import { connect, ResolveThunks } from "react-redux";
import { DealerDetailsPageContext } from "@insite/content-library/Pages/DealerDetailsPage";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

import { DealerModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { DealersDataView } from "@insite/client-framework/Store/Data/Dealers/DealersState";

import { DealerStateContext } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import { DistanceUnitOfMeasure } from "@NA/Components/ADIDistanceDisplay";
import DealerInformation from "@insite/content-library/Widgets/DealerDetails/DealerInformation";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import { LinkPresentationProps } from "@insite/mobius/Link";

const mapStateToProps = (state: ApplicationState) => {
    const { search } = getLocation(state);
    const { measure } = parseQueryString(search) as unknown as any;

    return {
        locationFinderUrl: getPageLinkByPageType(state, "LocationFinderPage")?.url,
        measure,
        getDealersParameter: state.pages.locationFinder.getDealersParameter,
        dealersDataView: getDealersDataView(state, state.pages.locationFinder.getDealersParameter),
        dealersDefaultLocation: getDealersDefaultLocation(state),
        settings: getSettingsCollection(state),

        dealerDetailsUrl: getPageLinkByPageType(state, "DealerDetailsPage")?.url,
    };
};
const mapDispatchToProps = {
    loadDealers,
    setParameter,
    customLoadDealers,
};
interface OwnProps extends WidgetProps {
    useLoadScript: ({ googleMapsApiKey }: { googleMapsApiKey: any }) => { isLoaded: false };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface ADIDealerInfoContainerStyles {
    leftColumnGridItem?: GridItemProps;
    locationSearchForm?: LocationSearchFormStyles;
    selectedDealerDisplayContainer?: GridContainerProps;

    selectedDealerDisplayGridItem?: GridItemProps;
    selectedDealerDisplay?: LocationFinderDealerDisplayPresentationProps;

    rightColumnGridItem?: GridItemProps;
    locationGoogleMap?: LocationGoogleMapStyles;
    dealerLocatorSearchFormGridItem?: GridItemProps;

    container?: GridContainerProps;
    dealerInfoGridItem?: GridItemProps;
    dealerMapGridItem?: GridItemProps;
    selectedDealerDisplayBackToResultsGridItem?: GridItemProps;
    selectedDealerDisplayBackToResultsLink?: LinkPresentationProps;
}

export const adiDealerInfoContainerStyles: ADIDealerInfoContainerStyles = {
    dealerLocatorSearchFormGridItem: {
        width: 12,
    },
    rightColumnGridItem: {
        width: [12, 12, 12, 12, 9],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            order: 1;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    leftColumnGridItem: {
        width: [12, 12, 12, 12, 3],
        css: css`
            padding-right: 0px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            order: 2;
                            padding-right: 10px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    container: {
        gap: 30,
    },
    dealerMapGridItem: {
        width: [12, 12, 12, 12, 9],
        css: css`
             @media (min-width: 1080px) {
            padding-left:20px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            order: 1;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    dealerInfoGridItem: {
        width: [12, 12, 12, 12, 3],
        css: css`
            @media (min-width: 1080px) {
            padding-right:5px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            order: 2;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    selectedDealerDisplayBackToResultsGridItem: {
        width: 12,
    },
    selectedDealerDisplayBackToResultsLink: {
        icon: {
            iconProps: {
                src: ChevronLeft,
            },
            position: "left",
        },
    },
    selectedDealerDisplayGridItem: {
        width: 12,
    },
};

const styles = adiDealerInfoContainerStyles;

export const ADIDealerInfoContainer: FC<Props> = ({
    id,
    history,
    locationFinderUrl,
    measure,
    dealersDataView,
    settings,
    useLoadScript,
    dealersDefaultLocation,
    dealerDetailsUrl,
    getDealersParameter,
    loadDealers,
    setParameter,
    customLoadDealers,
}) => {
    const { value: dealer } = useContext(DealerStateContext);
    const [matchedindexvalue, setMatchedIndexValue] = useState<number | null>(null);
    const [showGeoLocationErrorMessage, setShowGeoLocationErrorMessage] = React.useState(false);
    const [distanceUnitOfMeasure, setDistanceUnitOfMeasure] = React.useState<DistanceUnitOfMeasure>("Imperial");
    const [locationContentToDisplayModalOpen, setLocationContentToDisplayModalOpen] = React.useState<boolean>(false);
    const [locationContentToDisplay, setLocationContentToDisplay] = React.useState<LocationModel | undefined>(
        undefined,
    );
    const [defaultRadius, setDefaultRadius] = React.useState<number>(0);
    const [dealers, setDealers] = React.useState<DealerModel[]>([]);
    const [showSelectedDealer, setShowSelectedDealer] = React.useState<boolean>(false);
    const [resultCount, setResultCount] = React.useState<number>(0);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    const [selectedDealer, setSelectedDealer] = React.useState<DealerModel | undefined>(undefined);
    const [locationsPagination, setLocationsPagination] = React.useState<PaginationModel | undefined>();

    const [showColumns, setShowColumns] = useState(false);

    const { googleMapsApiKey } = settings.websiteSettings;

    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
    const { isLoaded } = useLoadScript({ googleMapsApiKey });
    const {
        googleMap,
        setGoogleMap,
        currentLocation,
        setCurrentLocation,
        isGoogleMapsScriptsLoaded,
        setBounds,
        setMapCenter,
        locationKnown,
    } = useGoogleMaps({
        isShown: true,
        isLoaded,
    });
    const onSearch = (searchFilter: string) => {
        setLocationSearchFilter(searchFilter);
    };
    React.useEffect(() => {
        if (!isGoogleMapsScriptsLoaded) {
            return;
        }
        if (dealersDataView.value && !dealersDataView.isLoading) {
            const { pagination, value: dealers, defaultRadius, defaultLatitude, defaultLongitude } = dealersDataView;

            setLocationSearchFilter(locationSearchFilter);
            setLocationsPagination(pagination || undefined);
            setResultCount(pagination?.totalItemCount || 0);
            setDefaultRadius(defaultRadius);
            setMapCenter(new google.maps.LatLng(defaultLatitude, defaultLongitude));
            setDealers(dealers || []);
            setIsLoading(false);
        } else {
            setIsLoading(true);
        }
    }, [dealersDataView, isGoogleMapsScriptsLoaded]);

    React.useEffect(() => {
        const bounds = [];
        closeInfoWindows();
        dealers.forEach(dealer => {
            bounds.push({ lat: dealer.latitude, lng: dealer.longitude });
        });
        if (showSelectedDealer && selectedDealer) {
            bounds.push({ lat: selectedDealer.latitude, lng: selectedDealer.longitude });
        }
        if (currentLocation && currentLocation.lat() !== 0 && currentLocation.lng() !== 0) {
            bounds.push({ lat: currentLocation.lat(), lng: currentLocation.lng() });
        }
        setBounds(bounds);
    }, [googleMap, dealers, selectedDealer, showSelectedDealer, currentLocation]);
    const [currentLocationInfoWindow, setCurrentLocationInfoWindow] = React.useState<
        CurrentLocationInfoWindow | undefined
    >(undefined);
    const [locationInfoWindow, setLocationInfoWindow] = React.useState<LocationInfoWindow<DealerModel> | undefined>(
        undefined,
    );
    const setLocationOfInfoWindow = (location: DealerModel | undefined) => {
        if (!location) {
            setLocationInfoWindow(undefined);
            return;
        }
        setLocationInfoWindow({
            position: new google.maps.LatLng(location.latitude, location.longitude),
            location,
        });
    };

    const handleBackToResults = () => {
        localStorage.setItem("searchresults", "false");
        localStorage.setItem("backResultFlag", "true");
      
        history.push(locationFinderUrl!);
    };

    const handleOpenContentModal = (dealer: LocationModel) => {
        setLocationContentToDisplayModalOpen(!!dealer.htmlContent);
        setLocationContentToDisplay(dealer);
    };
    const handleContentModalClose = () => {
        setLocationContentToDisplayModalOpen(false);
        setLocationContentToDisplay(undefined);
    };
    const [selectedLocationIndex, setSelectedLocationIndex] = useState("");
    const handleLocationSelected = (dealer: LocationModel, locationnumber: any) => {
        history.push(`${dealerDetailsUrl!}?id=${dealer.id}&measure=${distanceUnitOfMeasure}`);
        setSelectedLocationIndex(locationnumber);
    };
    const [geoLocationSearchText, setGeoLocationSearchText] = React.useState("");

    const handleLoadLocations = (parameter: GetDealersApiParameter) => {
        setParameter(parameter);
    };
    React.useEffect(() => {
        if (getDealersParameter) {
            customLoadDealers(getDealersParameter as any);
        }
    }, [getDealersParameter]);
    const createFilter = (coords: google.maps.LatLng | undefined, searchFilter: string): GetDealersApiParameter => {
        let centerPoint = { latitude: 0, longitude: 0 };

        if (coords && coords.lat() !== 0 && coords.lng() !== 0) {
            centerPoint = {
                latitude: coords.lat(),
                longitude: coords.lng(),
            };
        }

        if (centerPoint.latitude === 0 && centerPoint.longitude === 0 && selectedDealer) {
            centerPoint = {
                ...selectedDealer,
            };
        }

        if (
            centerPoint.latitude === 0 &&
            centerPoint.longitude === 0 &&
            dealersDefaultLocation.latitude !== 0 &&
            dealersDefaultLocation.latitude !== 0
        ) {
            centerPoint = dealersDefaultLocation;
        }

        return {
            name: searchFilter,
            latitude: centerPoint.latitude,
            longitude: centerPoint.longitude,
            page,
            pageSize,
        };
    };
    const { doSearch, locationSearchFilter, setLocationSearchFilter, page, setPage, pageSize, setPageSize } =
        useLocationFilterSearch<DealerModel, GetDealersApiParameter>({
            onSearch,
            loadLocations: handleLoadLocations,
            currentLocation,
            defaultRadius,
            selectedLocation: selectedDealer,
            setSelectedLocation: location => setSelectedDealer(location),
            setShowSelectedLocation: setShowSelectedDealer,
            createFilter,
        });

    const handleHover = (index: number | null) => {
        setHoveredIndex(index);
    };

    const handleGeoLocationSearch = (geoLocationSearch: string) => {
        setShowGeoLocationErrorMessage(false);
       

        getGeoCodeFromAddress(geoLocationSearch)
            .then(result => {
                const geocoderResult = result[0];
                if (geocoderResult.formatted_address) {
                    setGeoLocationSearchText(geocoderResult.formatted_address);
                }

                setPage(1);
                setCurrentLocation(geocoderResult.geometry.location);
            })
            .catch(() => {
                setShowGeoLocationErrorMessage(true);
            });
    };

    const handleSearch = (geoLocationSearch: string, locationSearch: string) => {
        if (!geoLocationSearch) {
            setShowGeoLocationErrorMessage(true);
            return;
        }
        setShowGeoLocationErrorMessage(false);
        if (geoLocationSearchText !== geoLocationSearch) {
            localStorage.setItem("searchresults", "true");
            localStorage.setItem("backResultFlag", "false");

            setLocationSearchFilter(locationSearch);
            handleGeoLocationSearch(geoLocationSearch);
            setShowColumns(true);

            return;
        }
        doSearch(locationSearch);
    };

    const { mapMarkersElements, closeInfoWindows, getLocationNumber } = useLocationGoogleMarkers({
        locations: dealers,
        locationSearchFilter,
        locationsPagination,
        currentLocation,
        selectedLocation: selectedDealer,
        showSelectedLocation: showSelectedDealer,
        setLocationOfInfoWindow,
        setCurrentLocationInfoWindow,
        hoveredIndex,
    });

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.dealerLocatorSearchFormGridItem} className="searchconta">
                <ADIDealerLocatorSearchForm
                    showGeoLocationErrorMessage={showGeoLocationErrorMessage}
                    geoLocationErrorMessage={siteMessage("DealerLocator_GeocodeErrorMessage")}
                    onSearch={handleSearch}
                    isLoading={isLoading}
                    geoLocationSearchText={geoLocationSearchText}
                    locationSearchFilter={locationSearchFilter}
                    extendedStyles={styles.locationSearchForm}
                    locationKnown={locationKnown}
                    locations={dealers}
                    siteMessageResultsErrorMessage={siteMessage("DealerLocator_NoResultsMessage")}
                ></ADIDealerLocatorSearchForm>
            </GridItem>
            {showColumns && (
                <>
                    <GridItem {...styles.leftColumnGridItem}>
                        {selectedDealer && (
                            <GridContainer {...styles.selectedDealerDisplayContainer}>
                                <GridItem {...styles.selectedDealerDisplayBackToResultsGridItem}>
                                    <Link
                                        onClick={handleBackToResults}
                                        {...styles.selectedDealerDisplayBackToResultsLink}
                                    >
                                        {translate("Back to Results")}
                                    </Link>
                                </GridItem>
                                <GridItem {...styles.selectedDealerDisplayGridItem}>
                                    <LocationFinderDealerDisplay
                                        {...styles.selectedDealerDisplay}
                                        dealer={selectedDealer}
                                        distanceUnitOfMeasure={distanceUnitOfMeasure}
                                    />
                                </GridItem>
                            </GridContainer>
                        )}
                        {!selectedDealer && (
                     
                       
                            <LocationSearchForm
                                 extendedStyles={styles.locationSearchForm}
                                isLoading={isLoading}
                                onSearch={handleSearch}
                                onLocationSelected={handleLocationSelected}
                                locationKnown={locationKnown}
                                showSelectedLocation={showSelectedDealer}
                                getLocationNumberFromPagination={getLocationNumber}
                                openLocationContentDisplay={handleOpenContentModal}
                                resultCount={resultCount}
                                locationSearchFilter={locationSearchFilter}
                                geoLocationSearchText={geoLocationSearchText}
                                showGeoLocationErrorMessage={showGeoLocationErrorMessage}
                                geoLocationErrorMessage={siteMessage("DealerLocator_GeocodeErrorMessage")}
                                distanceUnitOfMeasure={distanceUnitOfMeasure}
                                setDistanceUnitOfMeasure={setDistanceUnitOfMeasure}
                                locations={dealers}
                                customlocations={dealers}
                                locationsPagination={locationsPagination}
                                setPage={setPage}
                                setPageSize={setPageSize}
                                siteMessageResultsErrorMessage={siteMessage("DealerLocator_NoResultsMessage")}
                                hoveredIndex={hoveredIndex}
                                onHover={handleHover}
                            />
                        )}
                    </GridItem>

                    <GridItem {...styles.rightColumnGridItem}>
                        {isGoogleMapsScriptsLoaded && (
                            <LocationGoogleMap
                                extendedStyles={styles.locationGoogleMap}
                                currentLocation={currentLocation}
                                locationSearchFilter={locationSearchFilter}
                                distanceUnitOfMeasure={distanceUnitOfMeasure}
                                setGoogleMap={setGoogleMap}
                                mapMarkerElements={mapMarkersElements}
                                locationInfoWindow={locationInfoWindow}
                                currentLocationInfoWindow={currentLocationInfoWindow}
                                handleOpenLocationContent={handleOpenContentModal}
                                hoveredIndex={hoveredIndex}
                                onMarkerHover={handleHover}
                                setPage={setPage}
                                setPageSize={setPageSize}
                                locationsPagination={locationsPagination}
                                selectedLocationIndex={selectedLocationIndex}
                            />
                        )}
                    </GridItem>
                </>
            )}
            {!showColumns && (
                <>
                    <GridItem {...styles.dealerInfoGridItem} className="container1">
                        <Zone zoneName="dealerInfoZone" contentId={id} />
                    </GridItem>
                    <GridItem {...styles.dealerMapGridItem} className="container2">
                        <Zone zoneName="dealerMapZone" contentId={id} />
                    </GridItem>
                </>
            )}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(withDynamicGoogleMaps(ADIDealerInfoContainer))),

    definition: {
        group: "Basic",
        displayName: "ADI Dealer Info Container",
    },
};
export default widgetModule;
